import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useDataBoxMessageFormContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import {
	Button,
	Dialog,
	FormCheckbox,
	Pagination,
	Space,
} from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';
import { scrollToTop } from '@gov-nx/web';

export const DocumentsModal = () => {
	const {
		documents,
		pageDocuments,
		pager,
		selectedDocuments,
		showDocumentsModal,
		goToPage,
		onDocumentsConfirm,
		onDocumentsModalClose,
		addDocument,
		removeDocument,
	} = useDataBoxMessageFormContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	return (
		<Dialog
			isOpen={showDocumentsModal}
			onClose={onDocumentsModalClose}
			title={<h3>{tn('nova-zprava.dokumenty.vybrat-z-mych-souboru')}</h3>}
			footer={
				<Button
					nativeType="button"
					color="primary"
					type="solid"
					size="m"
					isDisabled={selectedDocuments.length === 0}
					onClick={onDocumentsConfirm}
					aria-label={tn('nova-zprava.dokumenty.prilozit-vybrane')}>
					{tn('nova-zprava.dokumenty.prilozit-vybrane')}
				</Button>
			}>
			<ul className="gov-list--plain flex flex-col gap-6">
				{pageDocuments?.map((document) => (
					<li
						key={document.dokumentId}
						className="flex flex-col gap-1 [ md:flex-row md:gap-4 ]">
						<FormCheckbox
							field={{
								name: 'document' + document.dokumentId,
								isChecked: selectedDocuments.includes(
									document.dokumentId as number
								),
								label: {
									children: (
										<span>
											<strong className="break-all">{document.nazev}</strong>
											<Space />
											<time className="text-body-s whitespace-nowrap ml-9 [ md:ml-0 ]">
												{document.datumVytvoreni
													? toDateReadable(document.datumVytvoreni)
													: null}
											</time>
										</span>
									),
								},
								size: 's',
								// @TODO: Checkbox changes should be handled in context with formMethods.watch('document')
								onChange: (event) =>
									event.target.checked
										? addDocument(document.dokumentId as number)
										: removeDocument(document.dokumentId as number, true),
							}}
						/>
					</li>
				))}
			</ul>
			<div className="flex justify-center">
				{documents.length > pager.perPage ? (
					<div className="mt-6">
						<Pagination
							color="primary"
							size="m"
							pageSize={pager.perPage}
							current={pager.page}
							onPage={(page) => {
								scrollToTop();
								goToPage(page);
							}}
							wcag-label={tn('wcag.strankovani')}
							total={documents.length}
						/>
					</div>
				) : null}
			</div>
		</Dialog>
	);
};
